import styles from './company.module.scss';
import { CheckboxLabel, TextField } from '@frontend-workspace/react-shared-lib';
import { ILoan } from 'libs/webkua-lib/src/lib/_models/loan';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

/* eslint-disable-next-line */
export interface CompanyProps {
  loan?: ILoan
}

export function Company(props: CompanyProps) {
  const { t } = useTranslation();
  return (
    <Row>
      <Col md={8} xxl={6}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={props.loan?.user.company.name || ''}
            fullWidth
            label={t("standard.name")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.user.company.department || ''}
            fullWidth
            label={t("standard.department")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.user.company.id || ''}
            fullWidth
            label={t("standard.companyID")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.user.company.number || ''}
            fullWidth
            label={t("standard.number")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={4} xxl={6}>
        <div className="d-flex flex-column mb-3">
          <CheckboxLabel
            label={t("standard.academic")}
            checked={props.loan?.user.company.isAcademy}
            disabled={true}
          />
          <CheckboxLabel
            label={t("standard.blocked")}
            checked={props.loan?.user.company.isBlocked}
            disabled={true}
          />
          <CheckboxLabel
            label={t("standard.deleted")}
            checked={props.loan?.user.company.isDeleted}
            disabled={true}
          />
        </div>
      </Col>
    </Row>
  );
}

export default Company;